import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { DocumentAdjustmentSummaryQuery, DocumentAdjustmentSummaryQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(DocumentAdjustmentSummaryQuery)
@Wrapper(DocumentAdjustmentSummaryQueryHandlerBase)
export class DocumentAdjustmentSummaryQueryHandler {
    public constructor(
        http: Http
    ) { }
}
